import React, { useState } from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import {  Grid, Typography,TextField, Box } from "@mui/material";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faJs, faPython, faJava, faReact, faNodeJs, faDocker, faAws, 
  faGit, faGithub, faAngular, faVuejs, faSass, faBootstrap,faGitAlt
} from '@fortawesome/free-brands-svg-icons';
import { 
  faServer, faLaptopCode, faTools, faDatabase, faCloud 
} from '@fortawesome/free-solid-svg-icons';
import ReCAPTCHA from "react-google-recaptcha";

export const It = () => {
  const skills = [
    { category: 'Programmiersprachen', items: [
        { name: 'JavaScript', icon: faJs },
        { name: 'Python', icon: faPython },
        { name: 'Java', icon: faJava },
        { name: 'C#', icon: faLaptopCode },
        { name: 'PHP', icon: faServer },
        { name: 'Ruby', icon: faLaptopCode },
        { name: 'C++', icon: faLaptopCode },
        { name: 'Swift', icon: faLaptopCode },
        { name: 'Kotlin', icon: faLaptopCode },
        { name: 'SQL', icon: faDatabase }
    ]},
    { category: 'Frontend-Entwicklung', items: [
        { name: 'React.js', icon: faReact },
        { name: 'Angular', icon: faAngular },
        { name: 'Vue.js', icon: faVuejs },
        { name: 'Svelte', icon: faLaptopCode },
        { name: 'HTML5', icon: faLaptopCode },
        { name: 'CSS3', icon: faLaptopCode },
        { name: 'Sass/SCSS', icon: faSass },
        { name: 'Bootstrap', icon: faBootstrap },
        { name: 'Tailwind CSS', icon: faLaptopCode }
    ]},
    { category: 'Backend-Entwicklung', items: [
        { name: 'Node.js', icon: faNodeJs },
        { name: 'Express.js', icon: faLaptopCode },
        { name: 'Django', icon: faLaptopCode },
        { name: 'Flask', icon: faLaptopCode },
        { name: 'Spring Boot', icon: faLaptopCode },
        { name: 'Ruby on Rails', icon: faLaptopCode },
        { name: 'ASP.NET', icon: faLaptopCode },
        { name: 'Laravel', icon: faLaptopCode },
        { name: 'GraphQL', icon: faLaptopCode },
        { name: 'REST APIs', icon: faServer }
    ]},
    { category: 'Database Management', items: [
        { name: 'MySQL', icon: faDatabase },
        { name: 'PostgreSQL', icon: faDatabase },
        { name: 'MongoDB', icon: faDatabase },
        { name: 'SQLite', icon: faDatabase },
        { name: 'Redis', icon: faDatabase },
        { name: 'Oracle DB', icon: faDatabase },
        { name: 'Microsoft SQL Server', icon: faDatabase }
    ]},
    { category: 'Version Control', items: [
        { name: 'Git', icon: faGit },
        { name: 'GitHub', icon: faGithub },
        { name: 'GitLab', icon: faGitAlt },
        { name: 'Bitbucket', icon: faLaptopCode }
    ]},
    { category: 'DevOps & CI/CD', items: [
        { name: 'Docker', icon: faDocker },
        { name: 'Kubernetes', icon: faTools },
        { name: 'Jenkins', icon: faLaptopCode },
        { name: 'CircleCI', icon: faLaptopCode },
        { name: 'Travis CI', icon: faLaptopCode },
        { name: 'AWS CodePipeline', icon: faAws },
        { name: 'Azure DevOps', icon: faCloud },
    ]}
];
  const [formData, setFormData] = useState({
    company: "",
    name: "",
    help: "",
    languageSearch:"",
    phone: "",
    email: "",
    consent: "",
  });

  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      // Basic form validation
      if (
        !formData.company ||
        !formData.name ||
        !formData.help ||
        !formData.phone ||
        !formData.email
      ) {
        setErrorMessage("Please fill out all required fields.");
        return;
      }
      const htmlBody = `
      <p><b>Unternehmen:</b> ${formData.company}</p>
      <p><b>Ich heiße:</b> ${formData.name}</p>
      <p><b>Ich brauche:</b> ${formData.help}</p>
      <p><b>Welche Programmiersprachen suchen Sie:</b> ${formDataSeekers.languageSearch}</p>
      <p><b>Telefon:</b> ${formData.phone}</p>
      <p><b>Email:</b> ${formData.email}</p>
      <p><b>Consent:</b> ${formData.consent}</p>
    `;
      const response = await fetch("/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: "anfragen@mezu.de",
          subject: "IT FÜR UNTERNEHMEN",
          html: htmlBody,
        }),
      });

      if (response.ok) {
        setSuccessMessage("Email sent successfully!");
        setFormData({
          company: "",
          name: "",
          help: "",
          languageSearch:"",
          phone: "",
          email: "",
          consent: "",
        });
        window.grecaptcha.reset();
      } else {
        setErrorMessage("Failed to send email. Please try again.");
      }
    } catch (error) {
      setErrorMessage("Error sending email. Please try again.");
      console.error("Error sending email:", error.message);
    } finally {
      setLoading(false);
    }
  };
  // for jobs seekers

  const [formDataSeekers, setFormDataSeekers] = useState({
    name: "",
    phone: "",
    email: "",
    live: "",
    country: "",
    move: "",
    place: "",
    language: "",
    speaking: "",
    writing: "",
    consent: "",
  });

  const [load, setLoad] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSeekersInputChange = (e) => {
    const { name, value } = e.target;
    setFormDataSeekers((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSeekersSubmit = async (e) => {
    e.preventDefault();

    try {
      setLoad(true);

      // Basic form validation
      if (
        !formDataSeekers.name ||
        !formDataSeekers.phone ||
        !formDataSeekers.email ||
        !formDataSeekers.live ||
        !formDataSeekers.move ||
        !formDataSeekers.writing ||
        !formDataSeekers.speaking ||
        !formDataSeekers.language
      ) {
        setErrorMsg("Please fill out all required fields.");
        return;
      }

      const htmlBody = `
      <p><b>Ich heiße:</b> ${formDataSeekers.name}</p>
      <p><b>Telefon:</b> ${formDataSeekers.phone}</p>
      <p><b>Email:</b> ${formDataSeekers.email}</p>
      <p><b>Wohnst Du in Deutschland:</b> ${formDataSeekers.live}</p>
      <p><b>In welchem Land wohnst Du:</b> ${formDataSeekers.country}</p>
      <p><b>Möchtest Du nach Deutschland umziehen:</b> ${formDataSeekers.move}</p>
      <p><b>Möchtest Du im Büro oder im Homeoffice arbeiten:</b> ${formDataSeekers.place}</p>
      <p><b>Welche Programmiersprachen sprichst Du:</b> ${formDataSeekers.language}</p>
      <p><b>Wie gut sind Deine deutschen Sprachkenntnisse beim Sprechen:</b> ${formDataSeekers.speaking}</p>
      <p><b>Wie gut sind Deine deutschen Sprachkenntnisse beim Schreiben:</b> ${formDataSeekers.writing}</p>
    `;
      const response = await fetch("/send-email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: "jobs@mezu.de",
          subject: "IT FÜR ARBEITSSUCHENDE",
          html: htmlBody,
        }),
      });

      if (response.ok) {
        setSuccessMsg("Email sent successfully!");
        setFormDataSeekers({
          name: "",
          phone: "",
          email: "",
          live: "",
          country: "",
          move: "",
          place: "",
          language: "",
          speaking: "",
          writing: "",
          consent: "",
        });
        window.grecaptcha.reset();
      } else {
        setErrorMsg("Failed to send email. Please try again.");
      }
    } catch (error) {
      setErrorMsg("Error sending email. Please try again.");
      console.error("Error sending email:", error.message);
    } finally {
      setLoad(false);
    }
  };
  return (
    <div>
      <header id="header">
        <div className="intro-it">
          <div className="overlay">
            <div className="container">
              <div className="row">
                <div className="col-md-8 col-md-offset-2 intern-intro-text">
                  <h1>
                    IT
                    <span></span>
                  </h1>

                  {/* <a
                    href="#features"
                    className="btn btn-custom btn-lg page-scroll"
                  >
                    Learn More
                  </a>{" "} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <div>
        <div id="about">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-6">
                {" "}
                <img
                  src="img/callcenter1.jpg"
                  className="img-responsive"
                  alt=""
                />{" "}
              </div>
              <div className="col-xs-12 col-md-6">
                <div className="about-text">
                  <h2>Für Unternehmen</h2>
                  <p>
                    Wir können Ihnen helfen, wenn Sie in Deutschland, im
                    Nearshore oder Offshore Personal suchen. Sie können in
                    Deutschland wählen zwischen Festangestellten oder
                    Personalüberlassung, Sie können im Ausland wählen zwischen
                    Freelancern, die im Homeoffice für Sie arbeiten oder
                    Mitarbeiterinnen und Mitarbeitern, die festangestellt in
                    unseren Büros für Sie arbeiten oder wir suchen Menschen, die
                    in ihr Team passen und nach Deutschland umziehen wollen.
                  </p>
                </div>
              </div>
            </div>
            <div className="row"  style={{marginTop:"30px"}}>
            <Typography variant="h4" align="center" gutterBottom>
            Fähigkeiten in der Entwicklungsplattform
            </Typography>
            <Grid container spacing={2}>
                {skills.map((skillCategory, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                        <Box sx={{ textAlign: 'center', p: 2, border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                            <Typography variant="h6" gutterBottom>
                                {skillCategory.category}
                            </Typography>
                            <Grid container spacing={1} justifyContent="center">
                                {skillCategory.items.map((skill, idx) => (
                                    <Grid item xs={3} key={idx} sx={{ textAlign: 'center' }}>
                                        <FontAwesomeIcon icon={skill.icon} size="lg" />
                                        <Typography variant="body2" sx={{ mt: 0.5 }}>
                                            {skill.name}
                                        </Typography>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Grid>
                ))}
            </Grid>
          </div>
          </div>
        </div>

        <div className="container">
          <div className="col-md-12">
            <div className="row">
              <h3 style={{ textAlign: "center" }}>
                Bitte schildern Sie uns unverbindlich Ihren Bedarf, wir melden
                uns umgehend bei Ihnen.
              </h3>
              <Box className="form-box" sx={{ p: 2 }}>
                <form onSubmit={handleSubmit}>
                  <p className="form_label">Wie heißt Ihr Unternehmen?</p>
                  <TextField
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                    fullWidth
                    required
                    name="company"
                    value={formData.company}
                    onChange={handleInputChange}
                  />
                  <p className="form_label">Wie heißen Sie?</p>
                  <TextField
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                    fullWidth
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                  />
                  <p className="form_label">Wie können wir Ihnen helfen?</p>
                  <TextField
                    name="help"
                    value={formData.help}
                    onChange={handleInputChange}
                    required
                    fullWidth
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                  />
                   <p className="form_label">Welche Programmiersprachen suchen Sie?</p>
                  <TextField
                    fullWidth
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                    name="language"
                    value={formDataSeekers.languageSearch}
                    onChange={handleSeekersInputChange}
                  />
                  <p className="form_label">Wie können wir Sie telefonisch erreichen?</p>
                  <TextField
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    required
                    fullWidth
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                  />
                  <p className="form_label">Wie können wir Sie per Mail erreichen?</p>
                  <TextField
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                    fullWidth
                    type={"email"}
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                  />

                  <RadioGroup
                  className="daten-check"
                    row
                    required
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="consent"
                    value={formData.consent}
                    onChange={handleInputChange}
                  >
                    <FormControlLabel
                      value="Ja"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label={<span>Ich bin davon einverstanden, dass meine persönlichen Daten auch an <a href="/partnernetzwerk">unser Partnernetzwerk</a>, Arbeitgeber und Auftraggeber weitergeleitet werden können ausschließlich für die Beantwortung des Anliegens bzw. zu Zwecken der Auftragsvermittlung. Jegliche Verwendung meiner persönlichen Daten durch Dritte für sonstige Marketingzwecke ist ausgeschlossen.</span>}
                    />
                  </RadioGroup>
                  <div className="captcha_container">
                <ReCAPTCHA
                  sitekey="6LfbQJEpAAAAAP2uTj5sdv5bYMmex1NMqY7pbsjy"
                  hl="de"
                />
                </div>
                  {loading && <p>Loading...</p>}
                  {successMessage && (
                    <p style={{ color: "green" }}>{successMessage}</p>
                  )}
                  {errorMessage && (
                    <p style={{ color: "red" }}>{errorMessage}</p>
                  )}
                  <button
                    className="submit-form-btn"
                    variant="contained"
                    type="submit"
                  >
                    ANFRAGE ABSCHICKEN
                  </button>
                </form>
              </Box>
            </div>
          </div>
        </div>
        <div id="about">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="about-text">
                  <h2>Für Arbeitssuchende</h2>
                  <p>
                    Wir und unsere Partnerunternehmen beschäftigen aktuell
                    Menschen in Argentinien, Brasilien, China, Deutschland,
                    Frankreich, Griechenland, Kosovo, Philippinen, Tunesien und
                    der Türkei.
                  </p>

                  <div className="list-style">
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                      <h5>Du wohnst in Deutschland </h5>
                      <ul>
                        <li>suchst Arbeit in Deutschland?</li>
                        <li>suchst Arbeit im Homeoffice?</li>
                        <li>suchst Arbeit im Ausland?</li>
                      </ul>
                    </div>
                    <div className="col-lg-6 col-sm-6 col-xs-12">
                      <h5>Du wohnst im Ausland </h5>
                      <ul>
                        <li>suchst Arbeit im Homeoffice?</li>
                        <li>suchst Arbeit im Ausland?</li>
                        <li>suchst Arbeit in Deutschland?</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xs-12 col-md-6">
                {" "}
                <img
                  src="img/callcenter3.jpg"
                  className="img-responsive"
                  alt=""
                />{" "}
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="col-md-12">
            <div className="row">
              <h3 style={{ textAlign: "center" }}>
                Hier unverbindlich und kostenlos bewerben
              </h3>
              <Box className="form-box" sx={{ p: 2 }}>
                <form onSubmit={handleSeekersSubmit}>
                  <p className="form_label">Wie heißt Du?</p>
                  <TextField
                    fullWidth
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                    name="name"
                    value={formDataSeekers.name}
                    onChange={handleSeekersInputChange}
                  />

                  <p className="form_label">Wie können wir Dich telefonisch erreichen?</p>
                  <TextField
                    fullWidth
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                    name="phone"
                    value={formDataSeekers.phone}
                    onChange={handleSeekersInputChange}
                  />
                  <p className="form_label">Wie können wir Dich per Mail erreichen?</p>
                  <TextField
                    fullWidth
                    type={"email"}
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                    name="email"
                    value={formDataSeekers.email}
                    onChange={handleSeekersInputChange}
                  />
                  <p className="form_label">Wohnst Du in Deutschland? </p>
                  <RadioGroup
                    row
                    required
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="live"
                    value={formDataSeekers.live}
                    onChange={handleSeekersInputChange}
                  >
                    <FormControlLabel
                      value="ja"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="ja"
                    />
                    <FormControlLabel
                      value="nein"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="nein"
                    />
                  </RadioGroup>
                  {formDataSeekers.live === "nein" && (
                    <div>
                      <p className="form_label">In welchem Land wohnst Du? </p>
                      <TextField
                        fullWidth
                        inputProps={{ style: { fontSize: 15, padding: 10 } }}
                        name="country"
                        value={formDataSeekers.country}
                        onChange={handleSeekersInputChange}
                      />
                    </div>
                  )}

                  <p className="form_label">Möchtest Du nach Deutschland umziehen? </p>
                  <RadioGroup
                    row
                    required
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="move"
                    value={formDataSeekers.move}
                    onChange={handleSeekersInputChange}
                  >
                    <FormControlLabel
                      value="ja"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="ja"
                    />
                    <FormControlLabel
                      value="nein"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="nein"
                    />
                    <FormControlLabel
                      value="vielleicht"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="vielleicht"
                    />
                  </RadioGroup>
                  {formDataSeekers.move === "ja" && (
                    <div>
                      <p className="form_label">Möchtest Du im Büro oder im Homeoffice arbeiten? </p>
                      <RadioGroup
                        row
                        required
                        aria-labelledby="demo-row-radio-buttons-group-label"
                        name="place"
                        value={formDataSeekers.place}
                        onChange={handleSeekersInputChange}
                      >
                        <FormControlLabel
                          value="Büro"
                          InputLabelProps={{ style: { fontSize: 15 } }}
                          control={<Radio />}
                          label="Büro"
                        />
                        <FormControlLabel
                          value="Homeoffice"
                          InputLabelProps={{ style: { fontSize: 15 } }}
                          control={<Radio />}
                          label="Homeoffice"
                        />
                      </RadioGroup>
                    </div>
                  )}
                 
                  <p className="form_label">Welche Programmiersprachen sprichst Du?</p>
                  <TextField
                    fullWidth
                    inputProps={{ style: { fontSize: 15, padding: 10 } }}
                    name="language"
                    value={formDataSeekers.language}
                    onChange={handleSeekersInputChange}
                  />
                  <p className="form_label">
                    Wie gut sind Deine deutschen Sprachkenntnisse beim Sprechen?
                  </p>
                  <RadioGroup
                    row
                    required
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="speaking"
                    value={formDataSeekers.speaking}
                    onChange={handleSeekersInputChange}
                  >
                    <FormControlLabel
                      value="A1"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="A1"
                    />
                    <FormControlLabel
                      value="A2"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="A2"
                    />
                    <FormControlLabel
                      value="B1"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="B1"
                    />
                    <FormControlLabel
                      value="B2"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="B2"
                    />
                    <FormControlLabel
                      value="C1"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="C1"
                    />
                    <FormControlLabel
                      value="C2"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="C2"
                    />
                    <FormControlLabel
                      value="Muttersprache"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="Muttersprache"
                    />
                  </RadioGroup>
                  <p className="form_label">
                    Wie gut sind Deine deutschen Sprachkenntnisse beim Schreiben?
                  </p>
                  <RadioGroup
                    row
                    required
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="writing"
                    value={formDataSeekers.writing}
                    onChange={handleSeekersInputChange}
                  >
                    <FormControlLabel
                      value="A1"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="A1"
                    />
                    <FormControlLabel
                      value="A2"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="A2"
                    />
                    <FormControlLabel
                      value="B1"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="B1"
                    />
                    <FormControlLabel
                      value="B2"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="B2"
                    />
                    <FormControlLabel
                      value="C1"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="C1"
                    />
                    <FormControlLabel
                      value="C2"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="C2"
                    />
                    <FormControlLabel
                      value="Muttersprache"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label="Muttersprache"
                    />
                  </RadioGroup>

                  <RadioGroup
                  className="daten-check"
                    row
                    required
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="consent"
                    value={formDataSeekers.consent}
                    onChange={handleSeekersInputChange}
                  >
                    <FormControlLabel
                      value="Ja"
                      InputLabelProps={{ style: { fontSize: 15 } }}
                      control={<Radio />}
                      label={<span> Ich bin davon einverstanden, dass meine persönlichen Daten an <a href="/partnernetzwerk">unser Partnernetzwerk</a>, Arbeitgeber und Auftraggeber weitergeleitet werden können ausschließlich für die Beantwortung des Anliegens bzw. zu Zwecken der Jobvermittlung. </span>}
                    />
                  </RadioGroup>
                  <div className="captcha_container">
                <ReCAPTCHA
                  sitekey="6LfbQJEpAAAAAP2uTj5sdv5bYMmex1NMqY7pbsjy"
                  hl="de"
                />
                </div>
                  {load && <p>Loading...</p>}
                  {successMsg && <p style={{ color: "green" }}>{successMsg}</p>}
                  {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
                  <button
                    className="submit-form-btn"
                    variant="contained"
                    type="submit"
                  >
                    ANFRAGE ABSCHICKEN
                  </button>
                </form>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
